import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { DeleteGroupOrganizationModal } from './DeleteGroupOrganizationModal';

interface Props {
  groupId: string;
  organization: { id: string; name: string };
}

export const DeleteGroupOrganization: FC<Props> = ({ groupId, organization }): JSX.Element => {
  const [showDeleteGroupOrganizationModal, setShowDeleteGroupOrganizationModal] = useState(false);

  return (
    <>
      <Button
        htmlType="button"
        icon="delete"
        shape="circle"
        size="large"
        type="link"
        onClick={() => setShowDeleteGroupOrganizationModal(true)}
      />
      <DeleteGroupOrganizationModal
        groupId={groupId}
        onCancel={() => setShowDeleteGroupOrganizationModal(false)}
        onOk={() => setShowDeleteGroupOrganizationModal(false)}
        organization={organization}
        visible={showDeleteGroupOrganizationModal}
      />
    </>
  );
};
